// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2BCSA","name":"ConsentHeader_name__3sTLi","birthday":"ConsentHeader_birthday__1BY2r","skeleton":"ConsentHeader_skeleton__1v_9I"};